import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

export function extractApiError(err) {
  if (!err) return 'Unknown error';
  const resp = err.response;
  if (resp) {
    const detail = resp.data && (resp.data.detail || resp.data.message || resp.data.error);
    if (detail) {
      if (typeof detail === 'string') return detail;
      try { return JSON.stringify(detail); } catch { return String(detail); }
    }
    return `HTTP ${resp.status} ${resp.statusText || ''}`.trim();
  }
  if (err.code === 'ECONNABORTED') return 'The request timed out. Please try again.';
  return err.message || 'Network error';
}

export async function generateStory(payload) {
  try {
    const { data } = await api.post('/story/generate', payload, { timeout: 120000 });
    return data;
  } catch (e) {
    e.userMessage = extractApiError(e);
    // eslint-disable-next-line no-console
    console.error('[TalesLore] generateStory failed:', e.userMessage, e.response?.data || e);
    throw e;
  }
}

export async function fetchStoryById(id) {
  const { data } = await api.get(`/story/${id}`, { timeout: 30000 });
  return data;
}

export async function fetchSampleStory() {
  const { data } = await api.get('/story/sample', { timeout: 90000 });
  return data;
}

export async function createCheckout(payload) {
  try {
    const { data } = await api.post('/payment/checkout', payload);
    return data;
  } catch (e) {
    e.userMessage = extractApiError(e);
    throw e;
  }
}

export async function verifyPayment(checkoutId) {
  const { data } = await api.post('/payment/verify', { checkout_id: checkoutId }, { timeout: 30000 });
  return data;
}

export async function getPaymentStatus(checkoutId) {
  const { data } = await api.get(`/payment/status/${checkoutId}`);
  return data;
}
